<template>
  <transition name="el-fade-in-linear">
    <div class="facebook-group-dialog-component">
      <hi-dialog class="dialog" title="Facebook group" @close="closeClick">
        <div class="modal">
          <div class="main-container">
            <div
              class="group-item"
              @click="itemClick(item)"
              v-for="item in list"
              :key="item.id"
            >
              <div
                class="image"
                v-lazy:background-image="item.url"
                :key="item.url"
              ></div>
              <div class="username">{{ item.name }}</div>
              <div class="icon" :class="{ select: item.select }"></div>
            </div>
          </div>
          <div class="bottom-container">
            <hi-button
              :disabled="!hasSelected"
              class="btn"
              @click.native="saveSelectClick"
              >Select</hi-button
            >
          </div>
        </div>
      </hi-dialog>
    </div>
  </transition>
</template>

<style lang="less" scoped>
.facebook-group-dialog-component {
  position: fixed;
  background: rgba(0, 0, 0, 0.5);
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  z-index: 100;
  .dialog {
    height: 700px;
  }
  .modal {
    width: 375px;
    height: 0;
    display: flex;
    flex-direction: column;
    flex: 1;
    .main-container {
      flex: 1;
      overflow: auto;
      .group-item {
        height: 60px;
        display: flex;
        align-items: center;
        padding: 0 20px;
        cursor: pointer;
        .image {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          background-position: center;
          background-size: cover;
          position: relative;
        }
        .username {
          margin-left: 15px;
          font-size: 15px;
          flex: 1;
        }
        .icon {
          width: 40px;
          height: 40px;
          background-size: contain;
          background-position: center;
          background-image: url("../../../public/images/common/Normal@3x.png");
          &.select {
            background-image: url("../../../public/images/common/Select@3x.png");
          }
        }
      }
    }
    .bottom-container {
      height: 64px;
      border-top: 1px solid #e5e5e5;
      display: flex;
      align-items: center;
      justify-content: center;
      .btn {
        height: 36px;
        width: 335px;
      }
    }
  }
}
</style>

<script>
import hiDialog from "../common/dialog/Index.vue";
import hiButton from "../common/button/Index";
import { showErrorMsg } from "../../utils/errors";
import { publishipsFacebook } from "../../service/publisher";
export default {
  name: "FacebookGroupModal",
  components: { hiDialog, hiButton },
  data() {
    return {
      selectIds: [],
      callback: () => {},
      group: [
        {
          name: "Demo1group",
          id: "666036334229526",
          url: "https://scontent-lax3-2.xx.fbcdn.net/v/t1.30497-1/p200x200/84576170_236604707358292_9025075784800272384_n.png?_nc_cat=1&_nc_sid=0c64ff&_nc_oc=AQlv5vujkPl15PyG4Oxb0UvBmDHd91yBX1Dx6x68H9I9X3MoN62IIo1iWGTY_dPb1-o&_nc_ht=scontent-lax3-2.xx&oh=68fa04f68f8642835625274bae511c9b&oe=5EA8FF25",
        },
        {
          name: "Demo1group",
          id: "666036334229521",
          url: "https://scontent-lax3-2.xx.fbcdn.net/v/t1.30497-1/p200x200/84576170_236604707358292_9025075784800272384_n.png?_nc_cat=1&_nc_sid=0c64ff&_nc_oc=AQlv5vujkPl15PyG4Oxb0UvBmDHd91yBX1Dx6x68H9I9X3MoN62IIo1iWGTY_dPb1-o&_nc_ht=scontent-lax3-2.xx&oh=68fa04f68f8642835625274bae511c9b&oe=5EA8FF25",
        },
      ],
      token: "",
    };
  },
  methods: {
    closeClick() {
      this.$emit("close");
    },
    setGroup({ group, token, callback = () => {} }) {
      this.group = group;
      this.token = token;
      this.callback = callback;
      this.selectIds = [];
    },
    /**
     * 选中事件
     */
    async itemClick(item) {
      const selectIndex = this.selectIds.findIndex((s) => s === item.id);
      // 没选中则进行选中
      if (selectIndex === -1) {
        this.selectIds.push(item.id);
      } else {
        // 选中则进行删除
        this.selectIds.splice(selectIndex, 1);
      }
    },
    /**
     * select按钮点击事件
     */
    async saveSelectClick() {
      const loading = this.$loading();
      try {
        await publishipsFacebook({
          social_user_token: this.token,
          selected_ids: this.selectIds.toString(),
          social_network: 3,
          homeLogin: true,
        });
      } catch (e) {
        showErrorMsg(e);
      } finally {
        loading.close();
        if (this.callback) {
          this.callback();
        }
        this.closeClick();
      }
    },
  },
  computed: {
    hasSelected() {
      return this.selectIds.length > 0;
    },
    list() {
      return this.group.map((item) => {
        const selectIndex = this.selectIds.findIndex((s) => s === item.id);
        return {
          id: item.id, // 唯一标识
          url: item.url, // 图片地址
          name: item.name, // 描述
          select: selectIndex !== -1,
        };
      });
    },
  },
};
</script>
